export const applicationsUnderReview = state => state.applicationsUnderReview
export const applicationUnderReviewById = state => id => _.find(applicationsUnderReview(state), {id})
export const applicationsUnderReviewByIds = state => ids => {
    return _.reduce(ids, (res, id) => {
        let application = applicationUnderReviewById(state)(id)
        if (application) res.push(application)
        return res
    }, [])
}

export const applicationsSignedOff = state => state.applicationsSignedOff
export const applicationSignedOffById = state => id => _.find(applicationsSignedOff(state), {id})
export const applicationsSignedOffByIds = state => ids => {
    return _.reduce(ids, (res, id) => {
        let application = applicationSignedOffById(state)(id)
        if (application) res.push(application)
        return res
    }, [])
}

export const applicationsByProjectId = (state) => {
    return project_id => {
        let types = [
            'occupancy_certificates',
            'after_hours_permits',
            'determinations',
            'misc_services',
            'dot_permits',
            'inspections',
            'violations',
            'trackings',
            'filings',
            'permits'
        ]

        return _.reduce(types, (res, type) => {
            _.each(
                _.filter(state.projects[_.kebabCase(type)].items, {project_id}),
                item => res.push(item)
            )
            return res
        }, [])
    }
}

export const applicationNumberByApplicationId = (state, getters) => (type, id) => {
    const application = _.find(getters[`${type}s`], {id: parseInt(id)})

    return application ? application.application_number : ''
}

export const applicationByTypeAndId = (state, getters) => (type, id) => {
    const applicationGetter = `${type.replace(/_/g, '-') + 's'}/itemById`

    return getters[applicationGetter](id)
}

export const applicationNameByTypeAndId = (state, getters) => (type, id) => {
    if (type && id) {
        const application = getters.applicationByTypeAndId(type, id)

        return getters.applicationName(application)
    }
}

export const applicationName = (state, getters) => (a) => {
    let typeName = getters.applicationTypeNameById(a.type)

    switch (a.type) {
        case 'after-hours-permit':
            return `${typeName} #${a.job_number} - ${a.numeric_type}`
        case 'determination':
            return `${typeName} ${a.job_number}`
        case 'dot-permit':
            return `${typeName} #${a.job_number} - ${getters.workTypeNameById(a.numeric_type)}`
        case 'filing':
            return `${typeName} #${a.job_number} - #${getters.filingApplicationTypeNameById(a.numeric_type)} - ${a.work_types_summary}`
        case 'inspection':
            return `${typeName} ${a.job_number}`
        case 'misc-service':
            return `${typeName} #${a.job_number} - ${a.numeric_type}`
        case 'occupancy-certificate':
            return `${typeName} #${a.job_number} - ${getters.occupancyCertificateTypeNameById(a.numeric_type)}`
        case 'permit':
            return `${typeName} #${a.job_number}`
        case 'tracking':
            return `${typeName} #${a.job_number} - ${getters.trackingTypeNameById(a.numeric_type)}`
        case 'violation':
            return `${typeName} #${a.job_number} - ${getters.violationTypeNameById(a.numeric_type)}`
    }
}
